import { render, staticRenderFns } from "./DataTablesComponent.vue?vue&type=template&id=455cc5f3&"
import script from "./DataTablesComponent.vue?vue&type=script&lang=js&"
export * from "./DataTablesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/sessions/wizardly-beautiful-ramanujan/mnt/bobino/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('455cc5f3')) {
      api.createRecord('455cc5f3', component.options)
    } else {
      api.reload('455cc5f3', component.options)
    }
    module.hot.accept("./DataTablesComponent.vue?vue&type=template&id=455cc5f3&", function () {
      api.rerender('455cc5f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/DataTablesComponent.vue"
export default component.exports